<script setup lang="ts">
import { inject, type ComponentPublicInstance } from 'vue';

import '@sg-core/src/View/Components/Atoms/Collapse/collapse.css';

import { PhxsgAccordionItemKey } from './phxsg-accordion-item.vue';

const itemContext = inject(PhxsgAccordionItemKey);

if (!itemContext) {
  throw new Error('PhxsgAccordionContent must be used inside a PhxsgAccordionItem');
}

const { id, contentRef } = itemContext;

function setContentRef(el: Element | ComponentPublicInstance | null): void {
  contentRef.value = el as HTMLElement | null;
}
</script>

<template>
  <div :id="`content-${id}`" :ref="setContentRef" class="phxsg-collapse">
    <div class="phxsg-accordion__content">
      <slot />
    </div>
  </div>
</template>
